module.exports = __webpack_public_path__ + "static/media/20_000013.6479aa7a.jpg";